import React from "react";
import PropTypes from "prop-types";

// styles
import PageLinkStyled from "./PageLink.styled";

const PageLink = ({ to, text, className, onClick }) => {

    return (
        <PageLinkStyled onClick={onClick} className={`${className}`} to={to}>
            {text}
        </PageLinkStyled>
    );
};

export default PageLink;

// props validation
PageLink.propTypes = {
    to: PropTypes.string,
    text: PropTypes.string,
    className: PropTypes.string,
    onClick: PropTypes.func
};
